export default __webpack_public_path__ + "static/inter-regular-webfont-ed62785c88111fbcf9bc486968797bf2.woff2";